import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core';

import { fetchGroupClients, fetchGroupDetails } from 'modules/clients/actions';

import GroupEmailRecipientsList from './GroupEmailRecipientsList';

import styles from './GroupEmailRecipientsList.styles';

const mapStateToProps = ({
  clientsModule: {
    groups: {
      groupDetails: { data: groupData, loading: groupDataLoading },
    },
  },
  clientingModule: { conversation },
}) => ({
  groupData,
  groupDataLoading,
  initialSelectedRecipientsAmount: conversation.recipients?.length,
});

const mapDispatchToProps = {
  fetchGroupClients,
  fetchGroupDetails,
};

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(GroupEmailRecipientsList);
